import ApplicationSerializer from './application';
import { dasherize } from '@ember/string';

export default ApplicationSerializer.extend({
  keyForAttribute(attr) {
    // envoy-web uses the term "blacklist", but garaje app code and mirage code both use the term "blocklist"
    // this allows the app's user serializer to expect payloads with the term blacklist without requiring that all our mirage code use the term "blacklist" also
    return dasherize(attr.replace('blocklist', 'blacklist'));
  },
});
